import * as React from "react"
import * as ReactDOM from "react-dom/client"

import { TooltipProvider } from "@shared/ui/components/tooltip"

import { I18nProvider } from "@/lib/i18n/client"
import { AppProviders } from "@/components/app-providers"
import { SiteHeader } from "@/components/layout/site-header"
import { SiteFooter } from "@/components/layout/site-footer"
import { MobileBottomCta } from "@/components/layout/mobile-bottom-cta"
import { HeroSection } from "@/components/sections/hero-section"
import { LiveScanSection } from "@/components/sections/live-scan-section"
import { SecurityScoreSection } from "@/components/sections/security-score-section"
import { DetectionGridSection } from "@/components/sections/detection-grid-section"
import { ThreatCenterSection } from "@/components/sections/threat-center-section"
import { ReportShowcaseSection } from "@/components/sections/report-showcase-section"
import { WorldPulseSection } from "@/components/sections/world-pulse-section"
import { KnowledgeBaseSection } from "@/components/sections/knowledge-base-section"
import { VoicesSection } from "@/components/sections/voices-section"

import "@/styles/globals.css"

function App() {
  return (
    <I18nProvider>
      <AppProviders>
        <TooltipProvider>
          <SiteHeader />
          <main className="pb-24 md:pb-0">
            <HeroSection />
            <LiveScanSection />
            <SecurityScoreSection />
            <DetectionGridSection />
            <ThreatCenterSection />
            <ReportShowcaseSection />
            <WorldPulseSection />
            <KnowledgeBaseSection />
            <VoicesSection />
          </main>
          <SiteFooter />
          <MobileBottomCta />
        </TooltipProvider>
      </AppProviders>
    </I18nProvider>
  )
}

const root = document.getElementById("root")!

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
